export default (container, done) => {
    document.body.classList.add('no-scroll');

    const leave = gsap.timeline({
        defaults: {
            ease: 'circ.inOut'
        },
        onComplete: () => {
            document.body.classList.remove('no-scroll');
            done();
        }
    });
    console.log('primary leave');
    const loaderWrapper = document.querySelector('[data-loader-wrapper]');

    const logo = document.querySelector('[data-loader-mark]');

    const curtainBlack = document.querySelector('[data-curtain-black]');
    const curtainWhite = document.querySelector('[data-curtain-white]');
    const curtainRed = document.querySelector('[data-curtain-red]');

    leave
    .set(loaderWrapper, { autoAlpha: 1 })
        .to(curtainWhite, { duration: 0.6, opacity: 1 });
        
};
